import PropTypes from 'prop-types';
import React from 'react';
import { getBackgroundColor, removeBackgroundColor } from '../../utils/getNewResource';

const PullQuoteSection = ({
  content: { credit, description, resource },
  isMobileSlideSection
}) => {
  const containsBackgroundColor = resource.indexOf('background-color:') > -1;
  const backgroundColor = containsBackgroundColor && getBackgroundColor(resource);
  const newResource = containsBackgroundColor ? removeBackgroundColor(resource) : resource;
  const color = (isMobileSlideSection && containsBackgroundColor) ? { color: backgroundColor } : {};
  const style = (!isMobileSlideSection && backgroundColor) ? { backgroundColor } : {};

  return (
    <div className="section-pull-quote" style={style}>
      <div className="quote-wrapper">
        <div className="quote-before">{'“'}</div>
        <p className="quote"
          style = {color}
          dangerouslySetInnerHTML={{ __html: newResource }}
        />
        {
          credit &&
          <div className="quote-credit"
            dangerouslySetInnerHTML={{ __html: credit }}
          />
        }
        <div className="quote-after">{'”'}</div>
      </div>
      {
        isMobileSlideSection && description &&
        <div className="quote-description"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      }
    </div>
  );
};

PullQuoteSection.propTypes = {
  content: PropTypes.shape({
    resource: PropTypes.string,
    credit: PropTypes.string,
    description: PropTypes.string
  }).isRequired,
  isMobileSlideSection: PropTypes.bool
};

PullQuoteSection.defaultProps = {
  content: {
    resource: ''
  }
};

export default PullQuoteSection;
